var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section-item',{style:({backgroundImage: 'url(' + require('@/assets/banner/service-banner.png') + ')' }),attrs:{"height":"600px"}}),_c('case-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }